class DirectoryViewModule {
    private static readonly DirectoryViewsKey: string = "DirectoryViews";
    private static readonly orderByFn = (a: IDirectoryView, b: IDirectoryView) => a.timestamp < b.timestamp ? -1 : 0;
    private directoryViews: IDirectoryView[];

    constructor() {
        try {
            const cachedDirectoryViews: string = localStorage.getItem(DirectoryViewModule.DirectoryViewsKey);
            if (cachedDirectoryViews) {
                const directoryViewsArr: IDirectoryView[] = JSON.parse(cachedDirectoryViews);
                this.directoryViews = directoryViewsArr?.sort(DirectoryViewModule.orderByFn).slice(-100) ?? [];
            }
            else {
                this.directoryViews = [];
            }
        } catch (error) {
            this.directoryViews = [];
        }
    }

    addDirectoryView(directoryView: IDirectoryView): void {
        if (directoryView?.directoryId && directoryView?.viewId) {
            const index: number = this.directoryViews.findIndex(x => x.directoryId === directoryView.directoryId);
            if (index > -1) {
                this.directoryViews[index] = directoryView;
            }
            else {
                this.directoryViews.push(directoryView);
            }    
            this.persist();
        }
    }

    getDirectoryView(directoryId: string): IDirectoryView {
        return directoryId && this.directoryViews.find(x => x.directoryId === directoryId);
    }

    removeDirectoryView(viewId: string): void {
        this.directoryViews = this.directoryViews.filter(x => x.viewId !== viewId);
        this.persist();
    }

    private persist() : void {
        Promise.resolve().then(() => {
            try {
                localStorage.setItem(DirectoryViewModule.DirectoryViewsKey, JSON.stringify(this.directoryViews));
            } catch (error) {
            }
        });
    }
}

const directoryViewModule = new DirectoryViewModule();
export default directoryViewModule;